




















































































































































































































































































































































































































































import Vue from 'vue';
import 'bootstrap-vue';
import Multiselect from 'vue-multiselect';
import Component from 'vue-class-component';
import VueElementLoading from "vue-element-loading";
import {Ax} from '@/utils';
import i18nService from "@/services/i18n";
import store from "@/services/store";
import CBudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import CBudgetAgreementModal from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue';
import CBudgetAgreementHistModal from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-hist-modal.vue';
import CBudgetSignLogModal from "@/modules/budget/components/budget-sign-log-modal.vue";
import CBudgetSignStatusModal from "@/modules/budget/components/budget-sign-status-modal.vue";
import BipCard from '@/modules/budget/bip/bip-card.vue';
import BipTest from '@/modules/budget/bip/bip-test.vue';
import BipLink from '@/modules/budget/bip/bip-link.vue';
import BipValues from '@/modules/budget/bip/bip-values.vue';
import BipModel from '@/modules/budget/bip/bip-model.vue';
import {
    BipProjectDataClass,
    checkAccess,
    checkFinCosts,
    DataType,
    defineBip,
    doRowKey,
    filterVersion,
    findItem,
    forInitiator,
    forRecipient,
    doNum,
    getRowKey,
    IInfo,
    initLogging,
    itemNameLocale,
    loadEbkMap,
    makeToast,
    nameLocale,
    postData,
    setCurVariant,
    setVariants,
    sortByField,
    versionByRegion,
    getYearRanges,
    Step,
    AgreementButtons,
    RowNewFinanceData,
    fetchJson,
    MSG_SMS,
    trMsg,
    MSG_CDF,
    MSG_BIP,
    MSG_FILTER,
    MSG_FIELD,
    MSG_CARD_SEC,
    getOperationCodes,
    createStatus,
    userUiid,
    showConfirmation,
    expTypes,
    repDatas,
    fetchReportBlob, DICT_CONFIG, pkgDicts, processPkgDicts, getInitialDicts
} from './bip-types';
import {loadVariants} from "@/modules/budget/budgetVariantService";

// декоратор @Component указывает, что класс — это компонент Vue
@Component({
    name: 'bip-form',
    components: {
        'multiselect': Multiselect,
        'c-budg-form-lst': CBudgetFormsList,
        'c-budg-agr-modal': CBudgetAgreementModal,
        'c-budg-agr-hist-modal': CBudgetAgreementHistModal,
        'c-sign-log-modal': CBudgetSignLogModal,
        'c-sign-status-modal': CBudgetSignStatusModal,
        'loading': VueElementLoading,
        BipCard,
        BipModel,
        BipTest,
        BipLink,
        BipValues
    }
})

export default class BipForm extends Vue {
    $refs!: {
        bipCard: HTMLFormElement;
        bipList: HTMLFormElement;
        drop: HTMLFormElement;
        bcPlanYear: HTMLFormElement;
        bcRegionBudget: HTMLFormElement;
        bcDataType: HTMLFormElement;
        bcVersion: HTMLFormElement;
        bcAbp: HTMLFormElement;
        bcPrg: HTMLFormElement;
        bcPpr: HTMLFormElement;
        refAgrModal: HTMLFormElement;
        refHistModal: HTMLFormElement;
        refSignLogModal: HTMLFormElement;
        refSignStatusModal: HTMLFormElement;
    }
    private curFormSelect = '/bip/bip-form';
    private mode = 'bip';
    private mode_code = '004.002.007';

    private MSG_BIP = MSG_BIP;
    private MSG_FILTER = MSG_FILTER;
    private MSG_CDF = MSG_CDF;
    private MSG_FIELD = MSG_FIELD;
    private MSG_CARD_SEC = MSG_CARD_SEC;

    private MESSAGES: IInfo = {
        info1: {
            ru: 'Данный раздел предназначен для ввода, просмотра и редактирования данных бюджетной заявки '
                + 'на определенный плановый период в части бюджетных инвестиционных проектов.',
            kk: 'Бұл бөлім Бюджеттік инвестициялық жобалар бөлігінде белгілі бір жоспарлы кезеңге арналған '
                + 'бюджеттік өтінім деректерін енгізуге, қарауға және түзетуге арналған.',
            en: 'This section is intended for entering, viewing and editing budget request data '
                + 'for a certain planning period in terms of budget investment projects.'
        },
        info2: {
            ru: 'Расшифровка включает в себя: общие сведения по проекту, источники финансирования, '
                + 'финансирование до начала планового периода, показатели для оценки приоритетности '
                + 'проекта.',
            kk: 'Расшифровка мыналарды қамтиды: жоба бойынша жалпы мәліметтер, қаржыландыру көздері, '
                + 'жоспарлы кезең басталғанға дейін қаржыландыру, жобаның басымдылығын бағалауға арналған көрсеткіштер.',
            en: 'The transcript includes: general information on the project, sources of financing, '
                + 'financing before the start of the planning period, indicators for assessing priority project.'
        }
    };
    private yearsFilter = getYearRanges();
    private dicts = getInitialDicts();

    private mode_level = 0;
    private pBar = 0; // прогресс загрузки списка

    private mode_opers: string[] = [];
    private location: any = {};

    private openFilterWindow = false; // открывает/скрывает меню Фильтра
    private backList = true; // признак переключения кнопки Назад
    private showForm = false; // показать/скрыть карту БИПа
    private showTest = false; // показать/скрыть критерии моделирования
    private saving = false; // признак Сохранения БИПа
    private savingInProgress = false; // идёт сохранение БИПа (защита от повторного запуска)
    private updateMark = false; // кнопка Обновить балл
    private host = true; // определение хоста для отображения КМ(критерии моделирования)
    private check = false; // признак отмеченных БИПов для действий
    private loading = false; // признак Загрузки списка БИПов
    private agree = false; // признак работы согласования

    private bipForm: any = undefined;
    private sign: any = {}; // инфо о подписи
    private meta: any = {}; // инфо о пользователе
    private costsMap: any = null; // данные
    private signMap: any = {}; // активные подписи по варианту и АБП

    // показатели фильтра
    private planPeriod: any = null;
    private selRegionBudget: any = null;
    private selDataType: any = null;
    private selVersion: any = null;
    private selAbp: any = null;
    private selPrg: any = null;
    private selPpr: any = null;

    // справочники для Фильтра
    private regionBudgetList: any[] = [];
    private versionList: any[] = [];
    private regionList: any[] = [];
    private spfList: any[] = [];

    private dataTypeList: DataType[] = [];
    private directionList: any[] = [];
    private objectList: any[] = [];
    private statusList: any[] = [];
    private gpList: any[] = [];
    private bipCifList: any [] = [];
    private criteriaValues: Map<any, any> = new Map();
    private bipLinkCriterias: any [] = [];
    private bipLinkTypes: any [] = [];
    private dictUnit: any [] = [];
    private fundSrcList: any [] = [];

    private bipList: any[] = []; // список БИПов по выбранной версии
    private prevList: any[] = []; // список БИПов по пред.версии
    private bipProjectData: BipProjectDataClass | null = null; // текущий БИП

    private levels: any = [];
    private regLevels: any = [];
    private ebkMap: Map<any, any> = new Map();
    private abpBase: any[] = [];
    private regAbpBase: any[] = [];

    private agrMap: Map<any, any> = new Map();
    private agrBtnLst: AgreementButtons = {
        back: [],
        forward: []
    };

    private appNum: number = 68; // datas for app68

    // Выносим тексты в константы для лучшей поддержки
    public created() {
        initLogging('form created');

        // nameLocale(this.expTypes);

        this.loadLocation();
        this.loadBudgetLevel();
        this.loadOperations();

        this.procPkgDicts();

        // this.loadBipPackageDicts();
   }

    public mounted() {
        initLogging('form mounted');
        const allowedHosts = new Set(['ea.csi.kz', 'nsi.csi.kz', 'localhost:10000']);
        this.host = allowedHosts.has(window.location.host);
        // Раскомментируйте при необходимости отладки
        // console.log('Current host:', window.location.host, 'Is allowed host:', this.host);

        // Раскомментируйте если нужно обрабатывать bip_id из URL
        // this.checkUrlForBipId();

        loadVariants().then((data) => {
            this.versionList = data.map((v) => {
                const ver: any = Object.assign({}, v);
                itemNameLocale(ver);
                const str = (ver.status
                    ? trMsg(this, MSG_FILTER + 'apprvd') + (ver.attribute ?  ', ' + trMsg(this, MSG_FILTER + 'act') : '')
                    : (ver.attribute ? trMsg(this, MSG_FILTER + 'act') : ''));
                Object.defineProperty(ver, 'text', {
                    get: function () {
                        return ver['name'] + (str.length > 0 ? ' (' + str + ')' : '');
                    }
                });
                return ver;
            });
            versionByRegion(this);
        });

        // Watchers for filter changes
        this.setupFilterWatchers();
        // Watchers for UI state changes
        this.setupUIStateWatchers();

        this.$watch('check', (value) => {
            for (const row of this.showBipList) {
                if (checkAccess(row, 'abp_agree', 'abp_agree_recipient', this.selRegionBudget.code)) {
                    this.$set(row, 'check', value);
                }
            }
        });

        this.$watch('agree', (value) => {
            if (value) {
                this.autoRevokeSign();
            }
        });
    }

    private checkUrlForBipId() {
        const urlParams = new URLSearchParams(window.location.search);
        const bipId = urlParams.get('bip_id');

        if (bipId) {
            const targetBip = this.bipList.find(bip => bip.id === parseInt(bipId));
            if (targetBip) {
                this.openBip(targetBip);
            }
        }
    }

    private setupFilterWatchers() {
        const filterWatchers = [
            { prop: "planPeriod",
                callback: (value: any) => {
                    if (value) {
                        initLogging('form planPeriod = ', value);
                        setCurVariant(this);
                    }
                } },
            { prop: "selRegionBudget",
                callback: (value: any) => {
                    if (value) {
                        initLogging('form selRegionBudget = ', value);
                        setCurVariant(this);
                    }
                } },
            { prop: "selDataType",
                callback: (value: any) => {
                    if (value) {
                        initLogging('form selDataType = ', value);
                        setCurVariant(this, true);
                    }
                } },
            {
                prop: "selVersion",
                callback: (value: any) => {
                    this.sign = undefined;
                    this.selAbp = null;
                    this.bipList = [];

                    if (value && !this.loading) {
                        initLogging('form selVersion ', value);
                        this.loading = true;
                        this.loadMetaDatas();
                        this.loadBipPackage();
                        this.getActSigns();
                    }
                }
            },
            {
                prop: "selAbp",
                callback: (value: any) => {
                    this.selPrg = null;
                    if (value === null) {
                        this.sign = undefined;
                    }
                    this.getBipSign('selAbp');
                }
            },
            { prop: "selPrg", callback: () => this.selPpr = null }
        ];

        filterWatchers.forEach(watcher => {
            this.$watch(watcher.prop, watcher.callback);
        });
    }

    private setupUIStateWatchers() {
        const uiStateWatchers = [
            {
                prop: "showForm",
                callback: (value: any) => value && (this.backList = this.showTest = false)
            },
            {
                prop: "showTest",
                callback: (value: any) => value && (this.backList = this.showForm = false)
            },
            {
                prop: "backList",
                callback: (value: any) => value && (this.showForm = this.showTest = false)
            }
        ];

        uiStateWatchers.forEach(watcher => {
            this.$watch(watcher.prop, watcher.callback);
        });
    }

    get access(): boolean {
        return ([2, 3].includes(this.mode_level) && this.selVersion?.attribute);
    }

    get abpFilter(): any[] {
        const abpSet = new Set(
            this.showBipList
                .map(b => b.addDatas?.abp?.abp)
                .filter(Boolean)
                .map(Number)
        );

        return Array.from(this.ebkMap.values()).filter((row) => abpSet.has(Number(row.abp)));
    }

    get prgFilter(): any[] {
        if (!this.selAbp) return [];

        const prgSet = new Set(
            this.showBipList
                .flatMap(b => b.addDatas?.finace || [])
                .map(f => f.prg)
                .filter(Boolean)
                .map(Number)
        );

        return this.selAbp.value.child
            .filter((row: any) => prgSet.has(Number(row.prg)));
    }

    get pprFilter(): any[] {
        if (!this.selPrg) return [];

        // 1. Используем flatMap и объединение массивов за одну операцию
        // 2. Применяем безопасное преобразование в число
        // 3. Используем оператор нулевого слияния для обработки null/undefined
        const pprSet = new Set(
            this.showBipList.flatMap(bip =>
                [...(bip.newFinace || []), ...(bip.newFinaceRegional || [])]
                    .map(fin => Number(fin.ppr ?? 0))
            )
        );

        // 4. Оптимизированная проверка вхождения значения
        return this.selPrg.value.child.filter((row: any) => pprSet.has(Number(row.ppr)));
    }

    get versionFilter(): any[] {
        return filterVersion(this);
    }

    get bipTableFields() {
        // Создаем хелпер для генерации заголовков с кэшированием
        const getTitle = (key: string) => trMsg(this, MSG_FIELD + key);
        const getCardSec = (key: string) =>
            trMsg(this, MSG_CARD_SEC + key);

        // Предварительно вычисляем повторяющиеся значения
        const currency = trMsg(this, MSG_CARD_SEC + '1.thousand_tg');
        const totalCostLabel = `${getCardSec('1.total_cost')} (${currency})`;
        const beforePlanLabel = `${getCardSec('3.financing_before_plan_period')}(${currency})`;
        const balanceLabel = `${getTitle('remaining_funding')} (${currency})`;

        return [
            { key: 'check', label: '', class: 'toggle-show' },
            { key: 'nom', label: '№' },
            { key: 'code', label: getTitle('project_code'), sortable: true },
            { key: 'name', label: getTitle('project_name'), sortable: true },
            { key: 'period', label: trMsg(this, MSG_CARD_SEC + '1.implementation_period'), sortable: true },
            { key: 'object', label: trMsg(this, MSG_FILTER + 'object_type'), sortable: true },
            { key: 'locality', label: getTitle('location'), sortable: true },
            { key: 'source', label: getTitle('source_funding_by_breakdown') },
            { key: 'totalCost', label: totalCostLabel, sortable: true },
            { key: 'costWithout', label: trMsg(this, MSG_CARD_SEC + '1.cost_PIR_GE'), sortable: true },
            { key: 'beforePlan', label: beforePlanLabel },
            { key: 'years', label: getTitle('amount_plan_period') },
            { key: 'balance', label: balanceLabel, sortable: true },
            { key: 'status', label: getTitle('project_status'), sortable: true },
            {
                key: 'sign_status',
                label: trMsg(this, MSG_CDF + 'sign_status'),
                sortable: true,
                thClass: this.selAbp ? '' : 'd-none',
                tdClass: this.selAbp ? '' : 'd-none'
            },
            { key: 'comments', label: getTitle('comments') },
            { key: 'more', label: '' }
        ];
    }

    get showBipList(): BipProjectDataClass[] {
        const { selVersion, selAbp, selPrg, selPpr, meta } = this;
        const userAbpSet = new Set(meta.userAbp);

        return this.bipList
            .filter(bip => !bip.isDeleted)
            .filter(bip => {
                if (selVersion &&
                    bip.variant !== selVersion.variant_uuid &&
                    bip.variant_recipient !== selVersion.variant_uuid) {
                    return false;
                }

                if (selAbp &&
                    Number(bip.addDatas?.abp?.abp) !== Number(selAbp.abp)) {
                    return false;
                }

                if (selPrg || selPpr) {
                    const hasPrg = selPrg
                        ? bip.addDatas?.finace?.some((f: any) => Number(f.prg) === Number(selPrg.prg))
                        : true;

                    const hasPpr = selPpr
                        ? bip.addDatas?.finace?.some((f: any) => Number(f.ppr) === Number(selPpr.ppr))
                        : true;

                    if (!hasPrg || !hasPpr) return false;
                }

                return userAbpSet.has(bip.header?.abp) ||
                    (bip.header?.regional && userAbpSet.has(bip.header?.regional?.abp));
            });
    }

    private getPeriodSum(bip: BipProjectDataClass) {
        let res = 0;
        const baseYear = Number(bip.header.year); // Парсим год один раз
        const { begYear, endYear } = bip.period; // Деструктуризация для удобства

        const listYears = [baseYear, baseYear + 1, baseYear + 2];
        // Выбираем источник данных
        const finance = this.selVersion.variant_uuid === bip.variant
            ? bip.newFinace
            : bip.newFinaceRegional;
        if (!finance) return res;

        for (const d of finance) {
            for (let i = begYear; i <= endYear; i++) {
                // @ts-ignore
                if (listYears.includes(i) && d[i] != undefined && d[i] !== '') {
                    // @ts-ignore
                    res = res + parseFloat(d[i]);
                }
            }
        }
        return res;
    }

    private info(name: string) {
        return this.MESSAGES[name][`${i18nService.locale}`];
    }

    private checkSign(bip: BipProjectDataClass): boolean {
        let result = true;
        const mainSign = this.signMap.get(doRowKey([bip.header.abp, bip.variant]));
        result = result && !(mainSign?.length > 0);

        if (bip.header?.finalAbp === 0) {
            const recipientSign = this.signMap.get(doRowKey([bip.header.regional.abp, bip.variant_recipient]));
            result = result && !(recipientSign?.length > 0);
        }

        return result;
    }

    private editBip(bip: BipProjectDataClass | null): boolean {
        if (!bip) return false;
        if (bip.id === 0) return true;

        const { header } = bip;
        const status = bip.addDatas?.status;

        let result = this.checkSign(bip) &&
            (header?.finalAbp === 1 ? this.meta.userGu.includes(header.gu.code) :
            (this.meta.userGu.includes(header?.regional?.gu?.code) &&
                this.selRegionBudget.code === bip.district_budget));

        if (status?.operation_code && status?.steps) {
            result = result && status.operation_code.includes('gu_edit');

            const operationCodes = getOperationCodes(status);
            result = result &&
                (header?.finalAbp === 1 ? operationCodes.includes('abp_agree') :
                    operationCodes.includes('abp_agree_recipient'));
        }

        return (result && this.access) || !status;
    }

    private editSection4(bip: BipProjectDataClass | null): boolean {
        if (!bip) return false;
        if (this.signMap.get(doRowKey([bip.header.abp, bip.variant]))) {
            return false
        }

        const status = bip.addDatas?.status;
        if (!status?.operation_code || !status.steps) {
            return this.editBip(bip) || !status;
        }

        const operationCodes = getOperationCodes(status);
        const { header } = bip;

        if (header?.finalAbp === 0 && header.regional &&
            !operationCodes.includes('abp_agree_recipient') &&
            operationCodes.includes('abp_agree')) {

            return this.selRegionBudget.code === bip.region_budget &&
                this.meta.userGu.includes(header?.gu?.code) &&
                status.operation_code.includes('gu_edit');
        }

        return this.editBip(bip) || !status;
    }

    private async createBip() {
        this.$root.$emit('removeClass');
        this.bipProjectData = new BipProjectDataClass({
            year: this.selVersion.year,
            dataType: this.selVersion.data_type,
            finalAbp: 1
        });
        defineBip(this, this.bipProjectData, 'form');
        this.showForm = true;
    }

    private async agreementEvent() {
        const selectedRows = this.showBipList.filter(row => row.check && row.addDatas?.status);

        if (selectedRows.length === 0) {
            makeToast(this, 'warning', trMsg(this, MSG_SMS + 'coordination'),
                trMsg(this, MSG_SMS + 'no_project_selected'));
            return;
        }

        const { firstStatus, firstHeader, validationError } = this.validateSelection(selectedRows);
        if (validationError) return;

        if (firstHeader) {
            this.mode_opers.push('abp_agree_recipient');
        }

        const nextSteps = await this.fetchNextSteps({
            modeCode: this.mode,
            operationCode: this.mode_opers.filter(item => item !== 'gu_edit' && !item.startsWith('ecp_sign')),
            agrCode: firstStatus
        });
        if (!nextSteps) return;

        if (nextSteps.length === 0) {
            makeToast(this, 'warning', trMsg(this, MSG_SMS + 'coordination'),
                trMsg(this, MSG_SMS + 'no_approval_steps_available'));
            return;
        }

        // Инициализация состояния кнопок
        this.agrBtnLst = { back: [], forward: [] };
        this.agrBtnLst = this.processNextSteps(nextSteps, firstStatus, firstHeader);

        if (this.agrBtnLst.back.length === 0 && this.agrBtnLst.forward.length === 0) {
            makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'),
                trMsg(this, MSG_SMS + 'insufficient_rights_negotiate'));
            return;
        }

        this.$refs.refAgrModal.showEvent();
    }

    private validateSelection(rows: any[]) {
        let firstStatus: number = 0;
        let firstHeader: boolean = false;

        for (const row of rows) {
            const status = row.addDatas?.status.code;
            const hasRegional = row.header?.hasOwnProperty('regional');

            if (firstStatus === 0) {
                firstStatus = status;
                firstHeader = hasRegional;
            }

            if (status !== firstStatus || hasRegional !== firstHeader) {
                const messageKey = status !== firstStatus
                    ? 'sel_BIPs_with_identical_stat'
                    : 'sel_BIPs_only_with_or_without_recipient';

                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'coordination'),
                    trMsg(this, MSG_SMS + messageKey));
                return { firstStatus: -1, firstHeader: false, validationError: true };
            }
        }

        // return { firstStatus, firstHeader, validationError: false };
        return {
            firstStatus: firstStatus ?? -1, // default value
            firstHeader: firstHeader ?? false,
            validationError: false
        };
    }

    private async fetchNextSteps(params: any) {
        try {
            const response = await fetch(`/api-py/get-step-next-back/${encodeURI(JSON.stringify(params))}`);
            const data = await response.json();
            nameLocale(data);
            return data;
        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-agreement-step-next-back ' + error.toString());
            return null;
        }
    }

    private processNextSteps(nextSteps: Step[], status: number, hasHeader: boolean) {
        const back: Step[] = []; // Явное указание типа
        const forward: Step[] = []; // Явное указание типа

        nextSteps.forEach((el: Step) => {
            const targetArray = el.stepType === 1 ? back : forward;

            if (status === 1) {
                const targetOperation = hasHeader ? 'abp_agree_recipient' : 'abp_agree';
                if (el.operationCode === targetOperation) {
                    targetArray.push(el); // Теперь тип элемента соответствует типу массива
                }
            } else {
                targetArray.push(el);
            }
        });

        return { back: back, forward: forward };
    }

    async agrClick(agree: any) {
        this.agree = false;
        const checkList = this.showBipList.filter(row => row.check && row.addDatas?.status);

        const newAgree = await Promise.all(
            checkList.flatMap(bip => this.processBipAgreement(bip, agree))
        ).then(results => results.flat());

        if (!newAgree.length) return;

        try {
            const response = await postData('/api-py/set_bip_agreement_step', newAgree);
            this.handleAgreementResponse(response, agree);
        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_save'), error.toString());
        }

        this.showBipList.forEach(row => this.$set(row, 'check', false));
    }

    private async processBipAgreement(bip: any, agree: any) {
        if (bip.header?.finalAbp === 1) {
            return [createStatus(agree, bip, bip.header, this.selVersion)];
        }

        return this.handleSpecialCases(bip, agree);
    }

    private async handleSpecialCases(bip: any, agree: any) {
        const results = [];

        if (this.selRegionBudget.code === bip.region_budget && this.meta.userGu.includes(bip.header?.gu?.code)) {
            const data = await forInitiator(this, 'uebp', bip, this.versionList);
            if (data?.versions_rec?.length && data.findDB === 0) {
                results.push(
                    createStatus(agree, bip, bip.header, this.selVersion),
                    createStatus(agree, bip, bip.header.regional, data.versions_rec[0])
                );
                await this.saveForm(bip, this.selVersion.variant_uuid, data.versions_rec[0].variant_uuid);
            }
        }

        if (this.selRegionBudget.code === bip.district_budget && this.meta.userGu.includes(bip.header?.regional?.gu?.code)) {
            const data = await forRecipient(this, 'uebp', bip, this.versionList);
            if (data?.versions?.length && data.findDB === 0) {
                results.push(
                    createStatus(agree, bip, bip.header, data.versions[0]),
                    createStatus(agree, bip, bip.header.regional, this.selVersion)
                );
                await this.saveForm(bip, data.versions[0].variant_uuid, this.selVersion.variant_uuid);
            }
        }

        return results;
    }

    private handleAgreementResponse(response: any[], agree: any) {
        response.forEach(res => {
            if (res.result === 'error') {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_save'), `${res.errTxt}`);
            } else {
                makeToast(this, 'success', trMsg(this, MSG_SMS + 'saving'),
                    trMsg(this, MSG_SMS + 'success'));
            }
        });

        if (agree.stepType === 1) {
            this.agree = true;
        }

        this.loadBipAgreement();
        this.getBipSign('handleAgreementResponse');
    }

    private async autoRevokeSign() {
        const params = {
            source: 'form',
            variant: this.selVersion.variant_uuid,
            abp: this.selAbp.abp,
            comment: null,
            user_id: userUiid,
            auto: true
        };
        try {
            const response = await postData('/api-py/revoke-bip-data', params);

            if (response?.result === 'success' && response?.res > 0) {
                makeToast(this, 'success',
                    trMsg(this, MSG_CDF + 'revoke_sign'),
                    trMsg(this, MSG_CDF + 'sign_revoked')
                );
                await this.getActSigns(); // Перенесено в блок успеха
            }
        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_CDF + 'error'),
                trMsg(this, MSG_CDF + 'request_failed') + ' /revoke-bip-data'
            );
        } finally {
            this.agree = false; // Сброс в любом случае
        }
    }

    private checkAccess(bip: BipProjectDataClass) {
        return checkAccess(bip, 'abp_agree', 'abp_agree_recipient', this.selRegionBudget.code);
    }

    private commentClk(agrObj: any) {
        if (!agrObj) return;

        // Устанавливаем mode только если значение изменилось
        if (agrObj.mode !== this.mode) {
            this.$set(agrObj, 'mode', this.mode);
        }

        // Безопасный вызов метода, если ref существует
        this.$refs.refHistModal?.showEvent(agrObj);
    }

    private defineBipList(serverList: BipProjectDataClass[]) {
        if (!serverList?.length) return;

        const startTime = performance.now();
        this.loading = true;
        this.pBar = 0;
        const step = 100 / serverList.length;

        try {
            serverList.forEach((bip, index) => {
                const bipObject = BipProjectDataClass.fromJSON(bip);
                defineBip(this, bipObject, 'form');

                this.bipList.push(bipObject);

                // Более предсказуемое обновление прогресса
                this.pBar = Math.min(100, Math.round((index + 1) * step));
            });

            // Сохраняем только последний элемент при необходимости
            this.bipProjectData = this.bipList.length > 0 ? this.bipList[this.bipList.length - 1] : null;
        } catch (error) {
            console.error('DefineBipList error:', error);
            throw new Error(`Bip processing failed: ${error instanceof Error ? error.message : error}`);
        } finally {
            initLogging(`formList: ${(performance.now() - startTime).toFixed(2)}ms`, this.bipList);
            this.loading = false;
            this.pBar = 100;
        }
    }

    private deleteAccess(bip: BipProjectDataClass) {

        if (!bip) return false;

        const hasEditAccess = bip.addDatas?.status?.operation_code?.includes('gu_edit') ?? false;
        if (!hasEditAccess) return false;

        const targetBudgetCode = !!bip.header?.regional ? bip.district_budget : bip.region_budget;

        return targetBudgetCode === this.selRegionBudget.code && this.checkSign(bip);
    }

    private async deleteBip(item: BipProjectDataClass) {
        try {
            const hasInvalidVersion = this.versionList
                .filter(row => row.variant_uuid === item.variant)
                .some(version => !version.attribute);

            if (hasInvalidVersion) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'removal'),
                    trMsg(this, MSG_SMS + 'del_project_impossible_initiator_version_not_current'));
                return;
            }

            if (item.header.regional && !this.meta.userGu.includes(item.header.regional.gu.code)) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'removal'),
                    trMsg(this, MSG_SMS + 'del_project_possible_only_by_recipient'));
                return;
            }

            await checkFinCosts(this, item);

            const hasEditedCosts = item.newFinace.some((row: any) => row.edited)
                || item.newFinaceRegional.some((row: any) => row.edited);

            if (hasEditedCosts) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'removal'),
                    trMsg(this, MSG_SMS + 'project_cannot_deleted_remove_supported_amount'));
                return;
            }

            await showConfirmation(this,
                `${trMsg(this, MSG_SMS + 'del_project_cannot_restored')}${item.code}?`,
                () => { this.saveBip(item, true, true); },
                () => {}, '');

        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_delete'),
                error.toString());
            this.saving = false;
        }
    }

    private async downloadRep68() {
        if (!(this.selAbp && this.selPrg)) {
            makeToast(this, 'primary', trMsg(this, MSG_SMS + 'warning'),
                trMsg(this, MSG_SMS + 'sel_ABP_BP'));
            return;
        }

        if (!await this.checkFinancingData()) return;

        try {
            const mainSigners = this.sign?.signers.sort(sortByField("order_num")) || [];

            if (mainSigners.length === 1 && !mainSigners[0]?.id_user) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'absent_signatories'));
            }

            await fetchReportBlob(this, this.appNum,
                this.planPeriod.year, this.selDataType.name, this.selVersion.variant_uuid,
                this.selAbp?.abp, this.selPrg?.prg, this.selPpr?.ppr ?? 0);
            // this.downloadExcelFile(blob);
        } catch (error) {
            makeToast(this, "danger", trMsg(this, MSG_SMS + 'attention'),
                trMsg(this, MSG_SMS + 'error_request') + ' /bip-application-' + this.appNum);
        }
    } // Приложение 68.xls

    private async checkFinancingData(): Promise<boolean> {
        const totalEntries = this.showBipList.reduce((sum, bip) => {
            const isVariantMatch = bip.variant === this.selVersion?.variant_uuid;
            const isRecipientMatch = bip.variant_recipient === this.selVersion?.variant_uuid;

            return sum +
                (isVariantMatch ? bip.newFinace.length : 0) +
                (isRecipientMatch ? bip.newFinaceRegional.length : 0);
        }, 0);

        if (totalEntries > 0) return true;

        makeToast(this, 'danger',
            this.trMsg(MSG_BIP + 'app') + ' ' + this.appNum,
            trMsg(this, MSG_SMS + 'information_financing_plan_period_not_filled'));
        return false;
    }

    private async downloadExcelFile(blobData: Blob) {

        const filename = `${this.trMsg(MSG_BIP + 'app')}_` + this.appNum
            + `_${[
            this.selAbp?.abp,
            this.selPrg?.prg,
            this.selDataType?.name,
            this.planPeriod?.year
        ].join('_')}.xls`;

        const url = window.URL.createObjectURL(new Blob([blobData]));
        const link = document.createElement('a');

        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    private findItem(code: number, field: string, list: any[]): any {
        return findItem(code, field, list);
    }

    private getBeforePlan(bip: BipProjectDataClass) {
        return bip.oldFinace.reduce((sum, obj) => sum + doNum(obj?.totalCoast), 0);
    }

    private async getActSigns() {
        if (!this.selVersion?.variant_uuid) return;

        try {
            const response = await fetch(`/api-py/get-active-signs/${this.selVersion.variant_uuid}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data: { signForm?: Record<string, unknown> } = await response.json();
            if (data?.signForm && typeof data.signForm === 'object') {
                this.signMap = new Map(Object.entries(data.signForm));
            } else {
                throw new Error('Invalid response format: missing signForm');
            }
        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                '/get-active-signs ' + error.toString());
        }
    }

    private async getBipSign(test: string = '') {

        if (!this.checkPrerequisites()) return;

        try {
            const { varLst, abpLst } = this.prepareRequestData();
            const params = {
                variant: this.selVersion.variant_uuid,
                region: this.selVersion.region_code,
                abp: this.selAbp.abp,
                mode: 'form',
                mode_code: this.mode_code,
                user_id: userUiid,
                recParams: {
                    source: 'uebp',
                    variant: Array.from(varLst),
                    abp: Array.from(abpLst)
                }};

            this.loading = true;
            const response = await postData('/api-py/get-bip-sign', params);
            response.signers = response.signers.filter((row: any) => row.id_user.length > 0);
            response.mapRecSigns = new Map(Object.entries(response.mapRecSigns));
            response.logMap = new Map(Object.entries(response.logMap));

            const userLog = (userUiid && response.logMap
                ? response.logMap.get(userUiid) || [] : []);
            const present = response.signers.filter((row: any) => row.id_user === userUiid);

            response.sign = !!(
                this.selVersion?.attribute &&
                this.selAbp &&
                present.length > 0 &&
                userLog.filter((row: any) => !row.deleted).length === 0
            );
            response.recall = !!(
                this.selVersion?.attribute &&
                this.selAbp &&
                present.length > 0 &&
                userLog.filter((row: any) => !row.deleted).length > 0 &&
                response.uebp.logList.filter((row: any) => !row.deleted).length === 0
            );
            response.agree = this.checkFullAgreement();

            let status = 0;
            let ownerSignFound = false;
            const totalSigners = response.signers.length;

            response.signers.forEach((row: any) => {
                const log = response.logMap.get(row.id_user) || []; // лог подписанта
                this.$set(row, 'log', log);

                const hasSign = log?.some((el: any) => !el.deleted);
                if (hasSign) {
                    status++;

                    if (row.id_user === userUiid) {
                        ownerSignFound = true;
                    }
                }

                if (row.id_user === userUiid) {
                    this.$set(response, 'ownerSign', hasSign);
                }
            });
            this.$set(response, 'ownerSign', ownerSignFound);

            this.$set(response, 'status', 0);
            if (totalSigners > 0) {
                this.$set(response, 'status',
                    status === totalSigners ? 1 :
                        status > 0 && status < totalSigners ? 2 : 0);
            }
            this.calculateFinancialTotals(response);

            [response.signers, response.uebp.signers].forEach(group => {
                nameLocale(group, 'code', 'sign_');
                nameLocale(group);
            });

            this.sign = response;
            initLogging('form sign', this.sign);
        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_load'),
                '/get-bip-sign' + error.toString());
        } finally {
            this.loading = false;
            await this.getActSigns();
        }
    }

    // Вспомогательные методы
    private checkPrerequisites(): boolean {
        if (userUiid && !this.selAbp) {
            return false;
        }
        return !!this.selVersion?.variant_uuid && !!this.selAbp?.abp;
    }

    private prepareRequestData() {
        const varLst = new Set<string>();
        const abpLst = new Set<string>();

        const filteredItems = this.showBipList.filter(row =>
            row.header.finalAbp === 0 && row.variant_recipient !== null
        );

        filteredItems.forEach(item => {
            varLst.add(item.variant_recipient);
            abpLst.add(item.header.regional.abp);
        });

        return { varLst, abpLst };
    }

    private checkFullAgreement(): boolean {
        const listStat = this.showBipList
            .filter(row => row.addDatas.status)
            .map(item => this.normalizeItemStatus(item));

        const approvedCount = listStat.filter(row =>
            this.checkApprovalConditions(row)
        ).length;

        return approvedCount > 0 && approvedCount === listStat.length;
    }

    private normalizeItemStatus(item: any) {
        if (!item.addDatas.status) {
            item.addDatas.status =
                {
                    code: 1,
                    name_ru: 'Заявка (Проект)',
                    name_kk: 'Өтінім (Жоба)',
                    name_en: 'Application (Project)',
                    operation_code: [],
                    comment: ''
                };
        }
        return item;
    }

    private checkApprovalConditions(row: any): boolean {
        const { code, operation_code } = row.addDatas.status;
        const regionCheck = this.selRegionBudget.code === row.region_budget && this.meta.userGu.includes(row.header?.gu?.code);
        const districtCheck = this.selRegionBudget.code === row.district_budget && this.meta.userGu.includes(row.header?.regional?.gu?.code);

        const result = regionCheck && operation_code?.includes('ecp_sign_abp') ?
            row.header.finalAbp === 1 ?
                [49, 51, 52].includes(code) :
                [45, 47, 48].includes(code) :
            row.header.finalAbp === 0 && districtCheck && operation_code?.includes('ecp_sign_abp_recipient') ?
                [40, 42, 45, 46, 47, 48].includes(code) : false;

        // const operationCheck = row.header.finalAbp === 1
        //     ? 'ecp_sign_abp'
        //     : 'ecp_sign_abp_recipient';
        //
        // const budgetCheck = row.header.finalAbp === 1
        //     ? this.selRegionBudget.code === row.region_budget
        //     : this.selRegionBudget.code === row.district_budget;
        //
        // const guCheck = row.header.finalAbp === 1
        //     ? this.meta.userGu.includes(row.header?.gu?.code)
        //     : this.meta.userGu.includes(row.header?.regional?.gu?.code);

        // return codes.includes(code) &&
        //     operation_code?.includes(operationCheck) &&
        //     budgetCheck && guCheck;

        return result;
    }

    private calculateFinancialTotals(response: any) {
        const totals = this.showBipList.reduce((acc, bip) => {
            bip.addDatas.finace.forEach((fin: any) => {
                acc.plan1 += fin.plan1;
                acc.plan2 += fin.plan2;
                acc.plan3 += fin.plan3;
            });
            return acc;
        }, { plan1: 0, plan2: 0, plan3: 0 });

        Object.assign(response, totals);
    }

    private getSources(bip: BipProjectDataClass) {
        type SourceKey = 5 | 11 | 15 | 28 | 32 | 42;
        const sourceMap: Record<SourceKey, string> = {
            5: 'ВЗ',
            11: 'РБ',
            15: 'МБ',
            28: 'ОБ',
            32: 'НФ',
            42: '042'
        };

        const finace = (bip.header.finalAbp === 1 || this.selVersion.variant_uuid === bip.variant)
            ? bip.newFinace
            : bip.newFinaceRegional;

        const sources = finace
            .map(d => d.ppr!)
            .sort((a: any, b: any) => (a - b > 0) ? 1 : -1)
            .map(ppr => {
                const key = ppr as SourceKey;
                return sourceMap[key] || '';
            })
            .filter(Boolean);

        return sources.join(', ');
    }

    private getYearsSum(bip: BipProjectDataClass) {
        // Суммируем oldFinace через reduce
        let res = bip.oldFinace.reduce((acc, old) => acc + (old?.totalCoast || 0), 0);

        // Прерываем выполнение, если нечего обрабатывать
        const headerYear = Number(bip.header.year);
        const finance: RowNewFinanceData[] = bip.header?.finalAbp === 1
            ? bip.newFinace
            : bip.newFinaceRegional;
        if (!finance) return res;

        // Оптимизация проверок и вычислений
        for (const fin of finance) {
            for (const key of Object.keys(fin)) { // На 5-10% быстрее, чем entries
                if (
                    key.length === 4 && // Проверка формата года
                    Number(key) >= headerYear // Числовая проверка
                ) {
                    const value = fin[Number(key)];
                    res += doNum(value) || 0; // Защита от NaN
                }
            }
        }

        return res;
    }

    private infoBip(info_id: number, file: string) {
        Ax(
            {
                url: '/api-py/get-info/' + info_id,
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data as BlobPart]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file + '.pdf');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_load'),
                    '/get-info/' + info_id + error.toString());
            }
        );
    }

    /**
     * открыть Журнал
     */
    private logEDS(mode: string) {
        if (!this.sign) return;

        // eslint-disable-next-line
        // @ts-ignore
        const params = {
            mode: this.mode,
            mode_sign: mode,
            version: this.selVersion,
            abp: this.selAbp,
            userGuList: this.meta.userGu,
            userUiid
        };

        this.$refs.refSignLogModal.showEvent(this.sign, params);
    }

    private async loadBipAgreement(code: string = '') {
        const params = {
            mode: this.mode,
            mode_code: this.mode_code,
            operation_code: this.mode_opers,
            variant: this.selVersion.variant_uuid,
            // Добавляем code, если он должен использоваться
            ...(code && { code }) // если параметр code нужен в запросе
        };

        try {
            const response = await postData('/api-py/get-bip-agreement-by-params', params);

            // Сразу создаем Map (проверка response не нужна, так как при ошибке будет исключение)
            const agrMap = new Map(Object.entries(response));

            // Обрабатываем элементы (предполагая, что itemNameLocale синхронная)
            for (const agr of agrMap.values()) {
                itemNameLocale(agr);
            }

            // Оптимизируем обновление bipList
            this.bipList.forEach(bip => bip && this.$set(bip.addDatas, "status", agrMap.get(bip.code)));

            // Сохраняем agrMap если нужно использовать позже
            this.agrMap = agrMap;

        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'attention'),
                `${trMsg(this, MSG_SMS + 'error_request')} /get-bip-agreement-by-params`
            );
            // Добавляем логирование ошибки
            console.error('Error loading BIP agreement:', error);
        }
    }

    private async loadBipPackageDicts() {

        const DICT_KEYS = [
            'budget_data_types', 'bip_project_type_list', 'bip_project_object_list',
            'agreement_status', 'program', 'unit', 'bip_cif_list',
            'bip_link_types', 'bip_link_criterias', 'bip_criteria_values',
            'funding_source', 'project_bank_form_data'
        ];

        try {
            const response = await postData('/api-py/bip-package-dicts', DICT_KEYS);

            // Извлечение и обработка данных
            const {
                budget_data_types,
                bip_project_type_list,
                bip_project_object_list,
                agreement_status,
                program,
                unit,
                bip_cif_list,
                bip_link_types,
                bip_link_criterias,
                bip_criteria_values,
                funding_source,
                project_bank_form_data
            } = response;

            // Основные присвоения
            this.dataTypeList = budget_data_types;
            this.directionList = bip_project_type_list.filter((row: any) => !['7', '8'].includes(row.code));
            this.objectList = bip_project_object_list;
            this.statusList = agreement_status.sort(sortByField('name_ru'));
            this.gpList = program;
            this.dictUnit = unit.sort(sortByField('code'));
            this.bipCifList = bip_cif_list.sort(sortByField('code'));
            this.bipLinkTypes = bip_link_types.sort(sortByField('id'));
            this.bipLinkCriterias = bip_link_criterias;
            this.fundSrcList = funding_source.filter((row: any) =>
                ['1', '2', '6', '7'].includes(row.code));

            // Массовая локализация
            const collectionsToLocalize = [
                this.dataTypeList, this.directionList, this.objectList,
                this.statusList, this.gpList, this.dictUnit,
                this.bipCifList, this.bipLinkTypes, this.bipLinkCriterias,
                bip_criteria_values, this.fundSrcList
            ];
            collectionsToLocalize.forEach(col => nameLocale(col));
            this.directionList.forEach(item => nameLocale(item.object_types));

            // Обработка критериев
            this.criteriaValues = new Map(
                bip_criteria_values.map((row: any) => [
                    getRowKey(row, ['criteria', 'link', 'year']), row])
            );

            // Оптимизированная обработка bipLinkCriterias
            this.bipLinkCriterias.forEach(blc => {
                try {
                    const [cif] = this.bipCifList.filter(row => row.code === blc.criteria);
                    if (cif) {
                        Object.entries(cif)
                            .filter(([key]) => !['id', 'begin_date', 'end_date'].includes(key))
                            .forEach(([key, value]) => this.$set(blc, key, value));

                        this.$set(blc, 'unit_item',
                            findItem(blc.unit, 'national_symbol', this.dictUnit));
                    }

                    const [blt] = this.bipLinkTypes.filter(row => row.id === blc.link);
                    if (blt) {
                        Object.entries(blt)
                            .filter(([key]) => key !== 'id')
                            .forEach(([key, value]) => this.$set(blc, key, value));

                        const setYear = (dateKey: string, yearKey: string) =>
                            this.$set(blc, yearKey,
                                blt[dateKey] ? new Date(blt[dateKey]).getFullYear() : null);

                        setYear('begin_date', 'begin_year');
                        setYear('end_date', 'end_year');
                    }
                } catch (error) {
                    console.error(`Criteria error [${blc.id}]:`, error);
                }
            });

        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                '/bip-package-dicts' + error.toString());
        }
    }

    async procPkgDicts() {
        const DICT_KEYS = Object.keys(DICT_CONFIG);

        try {
            const response = await pkgDicts(this, DICT_KEYS);

            await processPkgDicts(this, response);

            // Фильтрация fundSrcList после загрузки
            if (this.fundSrcList && Array.isArray(this.fundSrcList)) {
                this.fundSrcList = this.fundSrcList.filter((row: any) =>
                    ['1', '2', '6', '7'].includes(row.code)
                );
            }
        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                'procPkgDicts ' + error.toString());
        }
    }

    private async loadBipPackage() {

        const getPrevVariant = () => {
            const versions = this.versionList
                .filter(row => row.status &&
                    row.year === this.planPeriod.year - 1 &&
                    row.date_ueb &&
                    row.region_code === this.selRegionBudget.code)
                .sort(sortByField('date_ueb'));

            return versions.length ? versions[versions.length-1].variant_uuid : '';
        };

        try {
            const params = {
                mode: this.mode,
                mode_code: this.mode_code,
                operation_code: this.mode_opers,
                variant: this.selVersion.variant_uuid,
                prev_variant: getPrevVariant()
            };

            const response = await postData('/api-py/bip-package', params);
            this.pBar = 10;

            // Инициализация карт
            const mapEntries = (obj: object) => new Map(Object.entries(obj));
            this.ebkMap = mapEntries(response.abpMap);
            this.agrMap = mapEntries(response.agrMap);
            this.costsMap = mapEntries(response.costsMap);
            this.signMap = mapEntries(response.signForm);

            // Обработка списков
            this.spfList = response.spfList
                .filter((row: any) => row.type === 4)
                .sort(sortByField('spf'));
            nameLocale(this.spfList, 'spf');

            this.prevList = response.prevList
                .map((bip: BipProjectDataClass) => ({
                    ...bip,
                    nameCode: `${bip.code} - ${bip.nameRu}`
                }))
                .sort(sortByField('code'));

            await loadEbkMap(this, 'form');

            // Обработка основного списка
            if (response.bipList?.length && this.ebkMap.size) {
                this.pBar = 45;
                await new Promise(resolve => setTimeout(resolve, 3000));
                this.defineBipList(response.bipList);
            } else {
                makeToast(this, 'warning',
                    trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'no_datas_by_version'))
                this.pBar = 100;
                this.loading = false;
            }

        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                '/bip-package ' + error.toString());
        }
    }

    private async loadBudgetLevel() {
        try {
            const result = await fetchJson<Array<{ budget_level: string }>>(
                `/api-py/get-user-budget-level/${userUiid}`
            );

            const budgetLevel = result
                .map(el => {
                    const indx = el.budget_level.lastIndexOf('_');
                    return indx >= 0 ? parseInt(el.budget_level.slice(indx + 1)) : null;
                }).filter((level): level is number => level !== null);

            const levelMap: Record<number, { levels: number[]; regLevels: number[] }> = {
                2: { levels: [2], regLevels: [3] },
                3: { levels: [2, 3], regLevels: [3, 4] },
                4: { levels: [4, 3], regLevels: [4] }
            };

            const { levels, regLevels } = budgetLevel.reduce((acc, level) => {
                const config = levelMap[level];
                if (config) {
                    acc.levels.push(...config.levels.filter(l => !acc.levels.includes(l)));
                    acc.regLevels.push(...config.regLevels.filter(l => !acc.regLevels.includes(l)));
                }
                return acc;
            },
                { levels: [] as number[], regLevels: [] as number[] });

            this.levels = [...new Set(levels)];
            this.regLevels = [...new Set(regLevels)];

            if (budgetLevel.length === 0) {
                makeToast(this, 'warning',
                    trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'no_available_user_budget_levels'));
            }

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-user-budget-level ' + error.toString());
        } finally {
            initLogging('form budgetLevel', {levels: this.levels, regLevels: this.regLevels});
        }
    }

    private async loadBudgetRegions() {
        const that = this;
        try {
            const url = `/api-py/get-user-regions-by-obl/${this.location.obl}/${userUiid}`;
            this.regionBudgetList = await fetchJson<typeof that.regionBudgetList>(url);
            nameLocale(this.regionBudgetList);
            this.selRegionBudget = this.regionBudgetList[0] ?? null;

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-user-regions-by-obl ' + error.toString());
        } finally {
            initLogging('form regionBudgetList', this.regionBudgetList)
        }
    } // справочник регионов

    private async loadMetaDatas() {

        this.appNum = await repDatas('bip.app', this.planPeriod.year);
        if (!this.selRegionBudget) return;
        const that = this;
        try {
            const url = `/api-py/get-user-meta/${userUiid}/${this.selRegionBudget.code}`;
            this.meta = await fetchJson<typeof that.meta>(url);

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-user-meta ' + error.toString());
        } finally {
            initLogging('form userMeta', this.meta);
        }
    }

    // запрос локации по глобальному коду области
    private async loadLocation() {
        const that = this;

        try {
            const url = `/api-py/get-budget-obl/${store.state._instanceCode}`;
            this.location = await fetchJson<typeof that.location>(url);

            await Promise.all([
                this.loadBudgetRegions(),
                this.loadRegions()
            ]);

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-budget-obl ' + error.toString());
        } finally {
            initLogging('form location', this.location);
        }
    }

    private async loadOperations() {
        if (!userUiid || !this.mode_code) return;

        try {
            const url = `/api-py/user-modules/${userUiid}/${this.mode_code}`;
            const [response] = await fetchJson<Array<{
                operations?: string;
                access_level?: number;
            }>>(url);

            if (response?.operations) this.mode_opers = Array.isArray(response.operations)
                ? response.operations
                : response.operations.split(',');
            // this.mode_opers = response.operations;
            if (response?.access_level) this.mode_level = response.access_level;

        } catch (error) {
            makeToast(this, "danger",
                trMsg(this, MSG_SMS +  'attention'),
                trMsg(this, MSG_SMS + 'error_request') + '/api-py/user-modules');
        } finally {
            initLogging('form UML', {mode_opers: this.mode_opers, mode_level: this.mode_level});
        }
    }

    private async loadRegions() {
        if (!this.location?.code) return;

        try {
            const regions = await fetchJson<Array<{ code: string }>>(
                `/api-py/get-kato-regions/${this.location.code}`);

            const processedRegions = await Promise.all(
                regions.map(async region => {
                    // для ГРЗ (AB >= 71) строка самого города должна остаться в списке (EAK-462)
                    if (region.code[2] === '0' && parseInt(region.code.slice(0, 2), 10) < 71) return null;

                    try {
                        const localities = await fetchJson<Array<any>>(
                            `/api-py/get-kato-localities/${region.code.slice(0, 4)}`
                        );
                        nameLocale(localities);
                        return { ...region, localityList: [{ name: '' }, ...localities] };
                    } catch (error) {
                        makeToast(this, 'danger',
                            trMsg(this, MSG_SMS + 'attention'),
                            trMsg(this, MSG_SMS + 'error_request') + ' /get-kato-localities');
                        return { ...region, localityList: [] };
                    }
                })
            );

            this.regionList = processedRegions
                .filter((region): region is NonNullable<typeof region> => !!region)
                .sort((a, b) => a.code.localeCompare(b.code));

            nameLocale(this.regionList);

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_request'),
                '/get-kato-regions ' + error.toString());
        } finally {
            initLogging('form regionList', this.regionList);
        }
    }

    private message(form: BipProjectDataClass, sms: string) {
        const modalConfig = {
            title: trMsg(this, MSG_SMS + 'attention'),
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: trMsg(this, MSG_BIP + 'btn.cancel'),
            cancelTitle: trMsg(this, MSG_BIP + 'btn.correct'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
            modalClass: 'del-item-modal-script'
        };

        this.$bvModal.msgBoxConfirm(sms, modalConfig)
            .then(value => {
                this.saving = false;
                if (value) {
                    this.showForm = false;
                    this.backList = true;
                    return;
                }

                if (!this.showForm) {
                    this.openBip(form, false);
                }
            }).catch(error => {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_control'), error.toString());
            });
    }

    public modeling(): void {
        this.showTest = !this.showTest;
        this.$root.$emit('bipModel', this.showTest);
        this.$root.$emit('removeClass', this.showTest);
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        let refItem: any;
        switch (refName) {
            case 'bcPlanYear':
                refItem = this.$refs.bcPlanYear;
                break;
            case 'bcRegionBudget':
                refItem = this.$refs.bcRegionBudget;
                break;
            case 'bcDataType':
                refItem = this.$refs.bcDataType;
                break;
            case 'bcVersion':
                refItem = this.$refs.bcVersion;
                break;
            case 'bcAbp':
                refItem = this.$refs.bcAbp;
                break;
            case 'bcPrg':
                refItem = this.$refs.bcPrg;
                break;
            case 'bcPpr':
                refItem = this.$refs.bcPpr;
                break;
            default:
                break;
        }
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private openBip(bip: BipProjectDataClass, emitOn: boolean = true) {
        this.bipProjectData = BipProjectDataClass.assign(bip);

        // Использование requestAnimationFrame вместо setTimeout для синхронизации с рендером
        requestAnimationFrame(() => {
            this.showForm = true;
        });

        if (emitOn) {
            this.$root.$emit('removeClass');
        }
    }

    private openSign() {
        // Использование optional chaining и nullish coalescing
        this.sign?.signers &&
        (this.$refs.refSignStatusModal as any)?.showEvent(this.sign.signers);
    }

    private async reCalculate() {
        try {
            await showConfirmation(this,
                trMsg(this, MSG_SMS + 'score_be_recalculated_saved'),
                () => {},
                () => { return });

            this.updateMark = true;
            this.saving = true;

        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'error_update'),
                error.toString());
        } finally {
            this.updateMark = false;
        }
    }

    private async saveBip(form: BipProjectDataClass, delet: boolean = false, sms: boolean = false) {
        if (form.header?.finalAbp === 1) {
            // если получателя нет
            if (!this.meta.userGu.includes(form.header?.gu?.code)) {
                this.message(form, trMsg(this, MSG_SMS + 'user_gu_match_initiator_gu'));
                return
            }

            if (this.selRegionBudget.code !== form.region_budget) {
                this.message(form, trMsg(this, MSG_SMS + 'gu_region_match_filter_region'));
                return
            }

            const versions = this.versionList.filter(row => row.attribute
                && row.year === this.planPeriod.year
                && row.data_type === parseInt(this.selDataType.code)
                && row.region_code === form?.region_budget);
            if (versions.length === 0) {
                let sms = 'Данные не будут сохранены, так как отсутствует актуальная версия бюджета:'
                    + ' Период - ' + this.planPeriod.name + ', Вид данных - ' + this.selDataType.code
                    + ', Регион бюджета - ' + form?.region_budget;
                if (`${i18nService.locale}` === 'kk') {
                    sms = 'Деректер сақталмайды, өйткені бюджеттің өзекті нұсқасы жоқ:'
                        + ' Кезең - ' + this.planPeriod.name + ', Деректер түрі - ' + this.selDataType.code
                        + ', Бюджет аймағы - ' + form?.region_budget;
                }
                if (`${i18nService.locale}` === 'en') {
                    sms = 'The data will not be saved because the current budget version is missing:'
                        + ' Period - ' + this.planPeriod.name + ', Data Type - ' + this.selDataType.code
                        + ', Budget region - ' + form?.region_budget;
                }
                this.message(form, sms);
                return
            }
            this.$set(form.header, 'dataType', versions[0].data_type);
            await this.saveForm(form, versions[0].variant_uuid, '', delet, true);
        } else { // если получатель имеется

            if (this.selVersion.variant_uuid === form.variant) {
                // console.log('сижу под Инициатором')
                if (!this.meta.userGu.includes(form.header?.gu?.code)) {
                    this.message(form, trMsg(this, MSG_SMS + 'user_gu_match_initiator_gu'));
                    return
                }

                if (form.id === 0 && this.selRegionBudget.code !== form.district_budget) {
                    this.message(form, trMsg(this, MSG_SMS + 'recipient_gu_region_match_filter_region'));
                    return
                }

                if (form.id > 0 && this.selRegionBudget.code !== form.region_budget) {
                    this.message(form, trMsg(this, MSG_SMS + 'gu_region_match_filter_region'));
                    return
                }

                if (this.selRegionBudget.code === form.region_budget && this.meta.userGu.includes(form.header?.gu?.code)) {
                    if (this.editSection4(form)) {
                        // дожидаемся всей цепочки сохранения, иначе флаг saving снимется раньше времени
                        const data: any = await forInitiator(this, 'form', form, this.versionList);
                        if (data.versions_rec && data.versions_rec.length > 0 && data.findDB === 0) {
                            await this.saveForm(form, form.id === 0 ? this.selVersion.variant_uuid : form.variant,
                                data.versions_rec[0].variant_uuid, data.findDB === 0 && delet ? delet : false, sms);
                        }
                        return
                    } else {
                        if (this.selRegionBudget.code !== form.district_budget) {
                            this.message(form, trMsg(this, MSG_SMS + 'recipient_gu_region_match_filter_region'));
                            return
                        }
                    }
                }
            }

            if (this.selVersion.variant_uuid === form.variant_recipient) {
                // console.log('сижу под Получателем')
                if (!this.meta.userGu.includes(form.header?.regional?.gu?.code)) {
                    this.message(form, trMsg(this, MSG_SMS + 'user_gu_match_recipient_gu'));
                    return
                }

                if (this.selRegionBudget.code !== form.district_budget) {
                    this.message(form, trMsg(this, MSG_SMS + 'gu_region_match_filter_region'));
                    return
                }

                if (this.selRegionBudget.code === form.district_budget && this.meta.userGu.includes(form.header?.regional?.gu?.code)) {
                    // дожидаемся всей цепочки сохранения, иначе флаг saving снимется раньше времени
                    const data: any = await forRecipient(this, 'form', form, this.versionList);
                    if (data.versions && data.versions?.length > 0 && data.findDB === 0) {
                        await this.saveForm(form, data.versions[0].variant_uuid, this.selVersion.variant_uuid,
                            data.findDB === 0 && delet ? delet : false, sms);
                    }
                    return
                }
            } else {
                this.message(form, trMsg(this, MSG_SMS + 'rec_version_does_not_match_version_filter'));
                return
            }
        }
    }

    public async saveForm(
        form: BipProjectDataClass | any,
        variant: string,
        variant_rec: string,
        delet: boolean = false,
        sms: boolean = false)
    {
        try {
            // Валидация версий
            await this.validateVersions([variant, variant_rec]);

            // Подготовка данных формы
            form.isDeleted = delet;
            form.versions = [form.variant, form.variant_recipient, variant, variant_rec];

            const { abp, locality, budget, needs, impact, total, status, status_recipient,
                name, name_kk, name_kz, name_en, name_ru, nameCode, ...bip } = form;

            const requestData = {
                form: bip,
                variant,
                variant_recipient: variant_rec,
                user_name: userUiid,
                params: {
                    variant: this.selVersion.variant_uuid,
                    mode: this.mode,
                    operation_code: this.mode_opers
                }
            };

            // Отправка данных
            const response = await postData('/api-py/save-bip-form', requestData);

            // Обновление данных
            await this.updateFormData(form, response);
            // Обновление UI
            setTimeout(() => { !delet && this.updateUI(form, response) }, 1000);


            await this.saveFinace(form, variant, variant_rec, sms);

            // Дополнительные действия
            if (sms)
                makeToast(this, 'success', trMsg(this, MSG_SMS + 'saving'),
                    trMsg(this, MSG_SMS + 'datas_saved'));

            if (!response.result) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_save'),
                    response.error);
                return;
            }

            if (delet && sms) {
                makeToast(this, 'success', trMsg(this, MSG_SMS + 'removal'),
                    trMsg(this, MSG_SMS + 'post_deleted'));
                return;
            }

        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_save'), '');
        }
        // флаг saving здесь не сбрасываем: его снимает updateBip после завершения всей цепочки
    }

    private async validateVersions(versions: string[]) {
        const checkVersion = async (version: string) => {
            if (!version) return;

            try {
                const response = await fetch(`/api-py/get-version/${version}`);
                if (!await response.json()) {
                    makeToast(this, 'warning',
                        trMsg(this, MSG_SMS + 'attention'),
                        `${trMsg(this, MSG_SMS + 'version_not_actual')} ${version}`);
                    throw new Error('Invalid version');
                }
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/get-version' + error.toString());
                throw error;
            }
        };

        await Promise.all(versions.filter(v => v).map(checkVersion));
    }

    private async updateFormData(form: BipProjectDataClass, data: any) {
        if (form.id === 0) {
            Object.assign(form, {
                id: data.id,
                code: data.code
            });
        } else {
            // this.bipList = this.bipList.filter(bip => bip.id !== form.id);
            let i = 0;
            for (const bip of this.bipList) {
                if (bip.id === data.id) {
                    this.bipList.splice(i, 1);
                    break;
                }
                i++;
            }
        }

        Object.assign(form, data?.bip);
    }

    private updateUI(form: BipProjectDataClass, data: any) {

        this.loadBipAgreement(data.code);
        this.bipProjectData = data?.bip && BipProjectDataClass.assign(data.bip);
        defineBip(this, this.bipProjectData, 'save');

        this.bipList.unshift(this.bipProjectData);

        if (this.showForm) {
            this.showForm = false;
            const foundBip = this.bipList.find(bip => bip.id === form.id);
            // this.bipForm.equal = foundBip;
            foundBip && this.openBip(foundBip, false);
        }
    }

    private async saveFinace(
        form: BipProjectDataClass,
        variant: any,
        variant_rec: any,
        sms: boolean = false)
    {
        // Общие настройки
        const currentYear = form?.header?.year;
        const yearRange = [currentYear, currentYear + 1, currentYear + 2];

        // Функция для создания базового элемента
        const createBaseItem = (isRegional: boolean) => ({
            isDeleted: form?.isDeleted,
            bip_code: form?.code,
            object: form?.object,
            region: isRegional ? form?.district_budget : form?.region_budget,
            data_type: isRegional ? form.header?.regional.dataType : form.header.dataType,
            abp: isRegional ? form?.header?.regional.abp : form?.header?.abp,
            gu: isRegional ? form?.header?.regional.gu?.code : form?.header?.gu?.code,
            cur_year: currentYear,
            variant: isRegional ? variant_rec : variant
        });

        // Функция обработки финансовых данных
        const processFinanceData = (sourceData: any[], isRegional: boolean) => {
            return sourceData.flatMap(obj =>
                Object.entries(obj)
                    .filter(([key]) => yearRange.includes(parseInt(key)))
                    .map(([year, value]) => ({
                        ...createBaseItem(isRegional),
                        gr: obj?.gr,
                        prg: obj?.prg,
                        ppr: obj?.ppr,
                        spf: obj?.spf,
                        year,
                        value
                    }))
            );
        };

        // Формируем данные
        const values = [
            ...(variant.length ? processFinanceData(form?.newFinace || [], false) : []),
            ...(form.header?.finalAbp === 0 && variant_rec.length && form?.newFinaceRegional
                ? processFinanceData(form?.newFinaceRegional, true)
                : [])
        ];

        if (!values.length) return;

        // Подготовка данных для отправки
        const requestData = {
            bip_code: form?.code,
            cur_year: currentYear,
            data_type: form?.header?.dataType,
            user_name: userUiid,
            variant,
            variant_recipient: variant_rec,
            versions: form?.versions,
            values
        };

        try {
            // const response = await fetch('/api-py/save-bip-budget-request-total/', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json;charset=utf-8' },
            //     body: JSON.stringify(requestData)
            // });
            //
            // if (!response.ok) throw new Error('Ошибка сервера');
            //
            // const result = await response.json();
            const result = await postData('/api-py/save-bip-budget-request-total/', requestData);

            if (result.result === 'success' && sms) {
                makeToast(this, 'success',
                    trMsg(this, MSG_SMS + 'saving'),
                    trMsg(this, MSG_SMS + 'datas_saved'));
            }
        } catch (error) {
            makeToast(this, 'danger',
                trMsg(this, MSG_SMS + 'warning'),
                trMsg(this, MSG_SMS + 'error_save'));
        }
        // const values = [];
        // if (variant.length > 0) {
        //     const item = {};
        //     this.$set(item, 'isDeleted', form?.isDeleted);
        //     this.$set(item, 'bip_code', form?.code);
        //     this.$set(item, 'object', form?.object);
        //     this.$set(item, 'region', form?.region_budget);
        //     this.$set(item, 'data_type', form.header.dataType);
        //     this.$set(item, 'abp', form?.header?.abp);
        //     this.$set(item, 'gu', form?.header?.gu?.code);
        //     this.$set(item, 'cur_year', form?.header?.year);
        //     this.$set(item, 'variant', variant);
        //
        //     const arr = [];
        //     for (const obj of form?.newFinace) {
        //         for (const [key, value] of Object.entries(obj)) {
        //             if (parseInt(key) >= parseInt(form?.header?.year)
        //                 && parseInt(key) <= parseInt(form?.header?.year) + 2) {
        //                 const val = {
        //                     gr: obj?.gr,
        //                     prg: obj?.prg,
        //                     ppr: obj?.ppr,
        //                     spf: obj?.spf,
        //                     year: key,
        //                     value: value
        //                 };
        //                 arr.push(val);
        //             }
        //         }
        //     }
        //
        //     for (const row of arr) {
        //         const newRow = Object.assign({}, item);
        //         this.$set(newRow, 'gr', row?.gr);
        //         this.$set(newRow, 'prg', row?.prg);
        //         this.$set(newRow, 'ppr', row?.ppr);
        //         this.$set(newRow, 'spf', row?.spf);
        //         this.$set(newRow, 'year', row?.year);
        //         this.$set(newRow, 'value', row?.value);
        //         values.push(newRow);
        //     }
        // }
        //
        // // Районный (конечный)
        // if (form.header?.finalAbp === 0 && form?.newFinaceRegional && variant_rec.length > 0) {
        //     const item = {};
        //     this.$set(item, 'isDeleted', form?.isDeleted);
        //     this.$set(item, 'bip_code', form?.code);
        //     this.$set(item, 'object', form?.object);
        //     this.$set(item, 'region', form?.district_budget);
        //     this.$set(item, 'data_type', form.header?.regional.dataType);
        //     this.$set(item, 'abp', form?.header?.regional.abp);
        //     this.$set(item, 'gu', form?.header?.regional.gu?.code);
        //     this.$set(item, 'cur_year', form?.header?.year);
        //     this.$set(item, 'variant', variant_rec);
        //
        //     const arr = [];
        //     for (const obj of form?.newFinaceRegional) {
        //         for (const [key, value] of Object.entries(obj)) {
        //             if (parseInt(key) >= parseInt(form?.header?.year)
        //                 && parseInt(key) <= parseInt(form?.header?.year) + 2) {
        //                 const val = {
        //                     gr: obj?.gr,
        //                     prg: obj?.prg,
        //                     ppr: obj?.ppr,
        //                     spf: obj?.spf,
        //                     year: key,
        //                     value: value
        //                 };
        //                 arr.push(val);
        //             }
        //         }
        //     }
        //
        //     for (const row of arr) {
        //         const newRow = Object.assign({}, item);
        //         this.$set(newRow, 'gr', row?.gr);
        //         this.$set(newRow, 'prg', row?.prg);
        //         this.$set(newRow, 'ppr', row?.ppr);
        //         this.$set(newRow, 'spf', row?.spf);
        //         this.$set(newRow, 'year', row?.year);
        //         this.$set(newRow, 'value', row?.value);
        //         values.push(newRow);
        //     }
        // }
        //
        // const newElem = {
        //     'bip_code': form?.code,
        //     'cur_year': form?.header?.year,
        //     'data_type': form?.header?.dataType,
        //     'user_name': this.userUiid,
        //     'variant': variant,
        //     'variant_recipient': variant_rec,
        //     'versions': form?.versions,
        //     'values': values
        // }
        //
        // if (values.length === 0) {
        //     return
        // }
        //
        // try {
        //     const response = await fetch('/api-py/save-bip-budget-request-total/', {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json;charset=utf-8'
        //         },
        //         body: JSON.stringify(newElem)
        //     });
        //     const result = await response.json();
        //     if (response.status === 200 && result.result === 'success') {
        //         if (sms) {
        //             makeToast(this, 'success',
        //                 trMsg(this, MSG_SMS + 'saving'),
        //                 trMsg(this, MSG_SMS + 'datas_saved'));
        //         }
        //         return true;
        //     }
        // } catch {
        //     makeToast(this, 'danger',
        //         trMsg(this, MSG_SMS + 'warning'),
        //         trMsg(this, MSG_SMS + 'error_save'));
        //     return false;
        // }
    }

    private async handleScrollBack(options: { emitModel?: boolean } = {}) {
        // Общая часть эмитов
        this.$root.$emit('removeClass', options.emitModel);
        if (options.emitModel) {
            this.$root.$emit('bipModel', true);
        }

        this.backList = true;

        // Общая логика с таймаутом
        await new Promise(resolve => setTimeout(resolve, 1000));

        try {
            if (this.access && this.bipForm && !this.bipForm.equal) {
                await showConfirmation(this, trMsg(this, MSG_SMS + 'save_changes'),
                    () => {
                        if (!this.bipForm.save) {
                            this.openBip(this.bipForm.form, false);
                            return;
                        }
                        this.saveBip(this.bipForm.form, this.bipForm.equal, true);
                    },
                    () => { this.bipForm.equal = true; }
                );
            }
        } catch (error) {
            makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_delete'),
                error instanceof Error ? error.message : String(error)
            );
        } finally {
            const listElement = this.$refs.bipList as HTMLElement;
            listElement?.scrollIntoView({ behavior: 'smooth' });
            this.showForm = false;
            await this.getBipSign('handleScrollBack');
        }
    }

    private async updateBip(item: any) {
        try {
            if (item.form.id === 0 || item.form.header.edited) {
                setVariants(this, item.form);
            }
            if (this.access && this.saving && item.form && item.save && !this.savingInProgress) {
                this.savingInProgress = true;
                try {
                    await this.saveBip(item.form, item.delete, true);
                } finally {
                    this.savingInProgress = false;
                }
            }
        } catch (error) {
            console.log('error updateBip => ', item, error.toString());
        } finally {
            // пока идёт сохранение, кнопка «Сохранить» остаётся недоступной
            if (!this.savingInProgress) {
                this.saving = false;
            }
            this.bipForm = item;
        }
    }

    // translate messages
    private trMsg(field: string) {
        return trMsg(this, field);
    }
}
